import React from 'react';
import { ArrowRight } from 'lucide-react';
import { styles } from '../../styles/globalStyles';

const HeroSection = () => {
  return (
    <section style={styles.hero}>
      <div style={styles.heroContent}>
        <h1 style={styles.heroTitle}>
          Run AI agents and MCP protocols on your private network with full control
        </h1>
        <p style={styles.heroSubtitle}>
          Agent Development Platform powers real-time, AI-driven decision-making in the most critical 
          commercial and government contexts. Connect multi-agent systems to operations.
        </p>
        <button style={styles.ctaButton}>
          <span>Start Building</span>
          <ArrowRight size={16} />
        </button>
      </div>
    </section>
  );
};

export default HeroSection;